const CACHE_KEY = "residency_hotel_ratings";
const CACHE_EXPIRY = 7 * 24 * 60 * 60 * 1000; // 7 days

// Real ratings fetched from Google Places API
export const HOTEL_RATINGS = {
  "Residency Hotel Ajao Estate Lagos": { rating: 4.2, totalRatings: 362 },
  "Residency Hotel Lekki Osapa London Lagos": { rating: 4.1, totalRatings: 209 },
  "Residency Hotel Lekki Phase 1": { rating: 4.2, totalRatings: 69 },
  "Residency Hotel Guzape Abuja": { rating: 4.1, totalRatings: 650 },
  "Residency Hotel Independence Layout Enugu": { rating: 4.2, totalRatings: 322 },
  "Residency Hotel Ogidi": { rating: 3.9, totalRatings: 309 },
  "Residency Hotel Chevron Lagos": { rating: null, totalRatings: 0 },
};

/**
 * Get ratings from cache
 */
const getCachedRatings = () => {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      const data = JSON.parse(cached);
      // Only use cache if it's valid and has all 6 hotels
      if (
        Date.now() - data.timestamp < CACHE_EXPIRY &&
        data.ratings &&
        Object.keys(data.ratings).length >= 6
      ) {
        return data.ratings;
      }
    }
  } catch (error) {
    console.error("Cache read error:", error);
  }
  return null;
};

/**
 * Save ratings to cache
 */
const saveToCache = (ratings) => {
  try {
    // Only cache if we have all 6 hotels
    if (Object.keys(ratings).length >= 6) {
      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ ratings, timestamp: Date.now() })
      );
    }
  } catch (error) {
    console.error("Cache write error:", error);
  }
};

/**
 * Match hotel name to rating key
 */
const findRating = (hotelName) => {
  const name = (hotelName || "").toLowerCase().trim();

  // Try exact match first
  for (const [key, value] of Object.entries(HOTEL_RATINGS)) {
    if (key.toLowerCase().trim() === name) {
      return value;
    }
  }

  // Try partial match — check if key words appear in hotel name
  for (const [key, value] of Object.entries(HOTEL_RATINGS)) {
    const keyLower = key.toLowerCase();
    const keyWords = keyLower.split(" ").filter(w => w.length > 3);
    const matchCount = keyWords.filter(w => name.includes(w)).length;
    if (matchCount >= 2) {
      return value;
    }
  }

  return null;
};

/**
 * Fetch ratings for hotels
 */
export const fetchHotelRatings = async (hotels) => {
  // 1. Check cache first
  const cached = getCachedRatings();
  if (cached) {
    return cached;
  }

  // 2. Build ratings from our known data
  const ratings = {};
  for (const hotel of hotels) {
    const match = findRating(hotel.hotelName);
    if (match) {
      ratings[hotel.hotelId] = match;
    }
  }

  // 3. Only cache if we have all hotels
  saveToCache(ratings);

  return ratings;
};

/**
 * Clear ratings cache
 */
export const clearRatingsCache = () => {
  localStorage.removeItem(CACHE_KEY);
};
